(ns ductile.ui.load-builder-v2.commands
  (:require [ductile.ui.components.filters :as filters]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.fields :as fields]
            [ductile.ui.load-builder-v2.reducer :as lb2reducer]
            [ductile.ui.load-builder-v2.selectors :as lb2sel]
            [ductile.ui.transport :as transport]))

(defn- edit-current-load [load]
  (cond-> (or load {})
    (keyword? (:ductile/id load))
    (dissoc :ductile/id)

    true
    (dissoc :draft?
            :draft/name
            :transport/kind)))

(defn make-commands
  [{:keys [dispatch!
           submit-shared-op!
           cell->menu-filter-action
           field-spec-map
           vehicle-id->transport
           state
           loads
           draft-transports
           active-filters
           vehicles-filters-key
           vehicles-filters-draft-key
           vehicles-filters-modal-key
           compute-focused-route!
           clear-focused-route!]}]
  (let [create-draft-at-id! (fn [id assigned-vehicle-ids]
                              (dispatch! {:event :draft/create
                                          :draft-id id
                                          :vehicle-ids assigned-vehicle-ids})
                              id)
        create-draft! (fn
                        ([] (create-draft-at-id! (lb2reducer/create-draft-id) []))
                        ([assigned-vehicle-ids]
                         (create-draft-at-id! (lb2reducer/create-draft-id) assigned-vehicle-ids))
                        ([id assigned-vehicle-ids]
                         (create-draft-at-id! id assigned-vehicle-ids)))
        move-vehicles-to-transport! (fn [target-id vehicle-ids]
                                      (dispatch! {:event :transport/move-to-transport
                                                  :target-id target-id
                                                  :vehicle-ids vehicle-ids}))
        move-vehicles-to-staging! (fn [vehicle-ids]
                                    (dispatch! {:event :transport/move-to-staging
                                                :vehicle-ids vehicle-ids}))
        remove-from-staging! (fn [vehicle-ids]
                               (dispatch! {:event :transport/remove-from-staging
                                           :vehicle-ids vehicle-ids}))
        create-draft-with-vehicles-at-id! (fn [id vehicle-ids]
                                            (dispatch! {:event :draft/create-with-vehicles
                                                        :draft-id id
                                                        :vehicle-ids vehicle-ids}))
        create-draft-with-vehicles! (fn
                                      ([vehicle-ids]
                                       (create-draft-with-vehicles-at-id! (lb2reducer/create-draft-id) vehicle-ids))
                                      ([id vehicle-ids]
                                       (create-draft-with-vehicles-at-id! id vehicle-ids)))
        dismiss-draft! (fn [transport-id]
                         (dispatch! {:event :draft/dismiss
                                     :transport-id transport-id}))
        rename-draft! (fn [transport-id name]
                        (dispatch! {:event :draft/rename
                                    :transport-id transport-id
                                    :name name}))
        hide-focused-route! (fn []
                              (submit-shared-op! {:op :hide-focused-route}))
        edit-transport! (fn [transport-id]
                          (dispatch! {:event :ui/set-editing-transport
                                      :transport-id transport-id})
                          (if-let [draft (get draft-transports transport-id)]
                            (fields/set-current-load! (edit-current-load draft))
                            (when-let [load (first (filter #(= transport-id (lb2sel/load-key %)) loads))]
                              (fields/set-current-load! (edit-current-load load))))
                          (deframe/route-assoc! ::transport/edit-transport true))
        focus-transport-route! (fn [transport-id]
                                 (submit-shared-op! {:op :focus-transport-route
                                                     :transport-id transport-id}))
        create-empty-draft! (fn []
                              (submit-shared-op! {:op :create-draft
                                                  :vehicle-ids []}))
        create-draft-from-staging! (fn []
                                     (submit-shared-op! {:op :create-draft
                                                         :vehicle-ids (:staging-ids @state)}))
        clear-staging! (fn [] (submit-shared-op! {:op :clear-staging}))
        update-selection! (fn [event row-id ordered-ids]
                            (dispatch! {:event :selection/click
                                        :row-id row-id
                                        :ordered-ids ordered-ids
                                        :toggle? (or (.-ctrlKey event) (.-metaKey event))
                                        :shift? (.-shiftKey event)}))
        update-drag-selection! (fn [{:keys [row-keys append?]}]
                                 (dispatch! {:event :selection/drag-commit
                                             :row-keys row-keys
                                             :append? append?}))
        preview-drag-selection! (fn [{:keys [row-keys append?]}]
                                  (dispatch! {:event :selection/drag-preview
                                              :row-keys row-keys
                                              :append? append?}))
        add-cell-filter! (fn [{:keys [filter-item mode]}]
                           (when filter-item
                             (let [updated (conj (vec active-filters) filter-item)]
                               (if (= mode :prefill-modal)
                                 (do
                                   (deframe/route-assoc! vehicles-filters-draft-key updated)
                                   (deframe/route-assoc! vehicles-filters-modal-key true))
                                 (deframe/route-assoc! vehicles-filters-key (filters/serialize-filters updated))))))
        open-menu! (fn [{:keys [event vehicle-id from source-transport-id visible-vehicle-ids]}]
                     (let [visible-set (set visible-vehicle-ids)
                           current-selection (:selected-vehicle-ids @state)
                           use-selection? (and (contains? current-selection vehicle-id)
                                               (every? visible-set current-selection))
                           selected-ids (vec (if use-selection?
                                               current-selection
                                               #{vehicle-id}))
                           vehicle (get vehicle-id->transport vehicle-id)
                           context-filter-action (when vehicle
                                                   (cell->menu-filter-action field-spec-map vehicle event))]
                       (when-not use-selection?
                         (dispatch! {:event :selection/clear})
                         (dispatch! {:event :selection/click
                                     :row-id vehicle-id
                                     :ordered-ids [vehicle-id]
                                     :toggle? false
                                     :shift? false}))
                       (dispatch! {:event :menu/set
                                   :menu {:x (.-clientX event)
                                          :y (.-clientY event)
                                          :vehicle-id vehicle-id
                                          :vehicle-ids selected-ids
                                          :source-transport-id source-transport-id
                                          :from from
                                          :context-filter-action context-filter-action}})))]
    {:create-draft! create-draft!
     :move-vehicles-to-transport! move-vehicles-to-transport!
     :move-vehicles-to-staging! move-vehicles-to-staging!
     :remove-from-staging! remove-from-staging!
     :create-draft-with-vehicles! create-draft-with-vehicles!
     :dismiss-draft! dismiss-draft!
     :rename-draft! rename-draft!
     :hide-focused-route! hide-focused-route!
     :edit-transport! edit-transport!
     :focus-transport-route! focus-transport-route!
     :create-empty-draft! create-empty-draft!
     :create-draft-from-staging! create-draft-from-staging!
     :clear-staging! clear-staging!
     :update-selection! update-selection!
     :update-drag-selection! update-drag-selection!
     :preview-drag-selection! preview-drag-selection!
     :add-cell-filter! add-cell-filter!
     :open-menu! open-menu!
     :compute-focused-route! compute-focused-route!
     :clear-focused-route! clear-focused-route!}))
